import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c3d04702"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex-video-list"
};
const _hoisted_2 = {
  class: "more-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_history_item = _resolveComponent("history-item");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, index) => {
    return _openBlock(), _createBlock(_component_history_item, {
      dataPart: `${$props.dataPart || _ctx.$route.name}-${index}`,
      class: "v-index-img-item-link",
      item: item,
      key: index
    }, null, 8, ["dataPart", "item"]);
  }), 128)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: {
      path: '/account/historyList',
      query: {
        ..._ctx.$route.query
      }
    },
    target: "_blank"
  }, {
    default: _withCtx(() => [_createTextVNode("查看更多")]),
    _: 1
  }, 8, ["to"])])]);
}